import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleTecnical } from "../hooks/roles/ProtectedRoleTecnical";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleResolver = React.lazy(
  () =>
    import(
      "../components/task/tecnical/tareaDetalleResolver/tarea-detalle-resolver"
    )
);
export function tareaDetalleResolverTp() {
  return (
    <Route
      path="/tarea-detalle-resolver-tarea-programada"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleTecnical>
              <LazySuspense>
                <TareaDetalleResolver />
              </LazySuspense>
            </ProtectedRoleTecnical>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
